import {
  createCoroutineUninterceptedGeneratorVersion1ji2no4l6ift5 as createCoroutineUninterceptedGeneratorVersion,
  intercepted2ogpsikxxj4u0 as intercepted,
  createCoroutineUninterceptedGeneratorVersion2gduom218i9ay as createCoroutineUninterceptedGeneratorVersion_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  Companion_instance1xjg859pd52fi as Companion_instance,
  _Result___init__impl__xyqfz823vatsdepqb9n as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { resumeCancellableWithInternalk8vmvm2je8v0 as resumeCancellableWithInternal } from '../internal/DispatchedContinuation.mjs';
import { DispatchException248dwsudeuh1h as DispatchException } from '../DispatchedTask.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function startCoroutineCancellable(_this__u8e3s4, completion) {
  // Inline function 'kotlinx.coroutines.intrinsics.runSafely' call
  try {
    var tmp = intercepted(createCoroutineUninterceptedGeneratorVersion(_this__u8e3s4, completion));
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_instance);
    resumeCancellableWithInternal(tmp, tmp$ret$2);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      dispatcherFailure(completion, e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function startCoroutineCancellable_0(_this__u8e3s4, receiver, completion) {
  // Inline function 'kotlinx.coroutines.intrinsics.runSafely' call
  try {
    var tmp = intercepted(createCoroutineUninterceptedGeneratorVersion_0(_this__u8e3s4, receiver, completion));
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_instance);
    resumeCancellableWithInternal(tmp, tmp$ret$2);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      dispatcherFailure(completion, e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function startCoroutineCancellable_1(_this__u8e3s4, fatalCompletion) {
  // Inline function 'kotlinx.coroutines.intrinsics.runSafely' call
  try {
    var tmp = intercepted(_this__u8e3s4);
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_instance);
    resumeCancellableWithInternal(tmp, tmp$ret$2);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      dispatcherFailure(fatalCompletion, e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function dispatcherFailure(completion, e) {
  var tmp;
  if (e instanceof DispatchException()) {
    tmp = e.g13_1;
  } else {
    tmp = e;
  }
  var reportException = tmp;
  // Inline function 'kotlin.Companion.failure' call
  var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(reportException));
  completion.rc(tmp$ret$0);
  throw reportException;
}
//region block: exports
export {
  startCoroutineCancellable_0 as startCoroutineCancellable3v5el961z6rj8,
  startCoroutineCancellable as startCoroutineCancellable18shtfwdieib,
  startCoroutineCancellable_1 as startCoroutineCancellable1tb4wrxetke45,
};
//endregion

//# sourceMappingURL=Cancellable.mjs.map
